import { DayType } from "../constants/DayType"

 export const getColorGroups = ({formTab}) => {
    if (formTab === 'work') {
      return [[DayType.P], [DayType.Ps], [DayType.D, DayType.Prz]]
    }

    if (formTab === 'off-work') {
      return [
        [DayType.W, DayType.Wo],
        [DayType.Pw],
        [
          DayType.Xw,
          DayType.Xb,
          DayType.Xd,
          DayType.Ws,
          DayType.Wn,
          DayType.Wx,
        ],
      ]
    }

    if (formTab === 'vacation') {
      return [
        [DayType.U, DayType.Uz, DayType.Uo],
        [
          DayType.U2,
          DayType.Bw,
          DayType.Ui,
          DayType.Un,
          DayType.Ur,
          DayType.Ux,
          DayType.Us,
          DayType.Um,
          DayType.Uf,
          DayType.Bp,
          DayType.D1,
          DayType.D2,
        ],
        [DayType.C, DayType.Cn, DayType.Cb, DayType.M, DayType.Uoj],
        [DayType.Z, DayType.Zb, DayType.Zn, DayType.Zs, DayType.Zw],
        [DayType.Od, DayType.Os, DayType.Or, DayType.Oo],
        [DayType.Rc, DayType.Rw, DayType.Rb],
      ]
    }

    if (formTab === 'absences') {
      return [[DayType.Nn, DayType.Np, DayType.Nu]]
    }

    if (formTab === 'allowances') {
      return [
        [DayType.C, DayType.Cn, DayType.Cb],
        [DayType.M, DayType.Uoj],
        [DayType.Z, DayType.Zb, DayType.Zs, DayType.Zw, DayType.Zn],
        [DayType.Od, DayType.Os, DayType.Or, DayType.Oo],
        [DayType.Rc, DayType.Rw, DayType.Rb],
      ]
    }

    if (formTab === 'other') {
      return [[DayType.Sw]]
    }

    return [[]]
  }